"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var auth_1 = require("firebase/auth");
var react_1 = __importDefault(require("react"));
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var BlendButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/BlendButton"));
var QRInput_1 = __importDefault(require("containers/Settings/MyAccount/Mfa/QRInput"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var TotpInput = function (_a) {
    var totpError = _a.totpError, close = _a.close;
    var _b = __read(react_1.default.useState(''), 2), totp = _b[0], setTotp = _b[1];
    var _c = __read(react_1.default.useState(false), 2), loading = _c[0], setLoading = _c[1];
    var _d = __read(react_1.default.useState(''), 2), errorMsg = _d[0], setErrorMsg = _d[1];
    var validateTotp = function () { return __awaiter(void 0, void 0, void 0, function () {
        var mfaResolver, multiFactorAssertion, err_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setLoading(true);
                    mfaResolver = (0, auth_1.getMultiFactorResolver)((0, auth_1.getAuth)(), totpError);
                    multiFactorAssertion = auth_1.TotpMultiFactorGenerator.assertionForSignIn(mfaResolver.hints[0].uid, totp.replace(/\s/, ''));
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, mfaResolver.resolveSignIn(multiFactorAssertion)];
                case 2:
                    _c.sent();
                    return [4 /*yield*/, (0, end2end_1.delay)(2000)];
                case 3:
                    _c.sent();
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _c.sent();
                    // Invalid or expired OTP.
                    setErrorMsg(((_b = (_a = err_1.customData) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.match(/auth\/invalid-verification-code/)) ? 'invalid-verification-code' : 'unknown-error');
                    return [3 /*break*/, 5];
                case 5:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, md: 4, my: "auto" }, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ spacing: 2, my: "auto", height: 1 }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 2 }, { children: "Enter the code displayed from your security app" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, color: "riverstone" }, { children: "We're asking for this code based on your two-factor authentication preferences" })), (0, jsx_runtime_1.jsx)(QRInput_1.default, { onChange: function (e) { return setTotp(e.target.value.replace(/\D/g, '').slice(0, 6)); }, onKeyDown: function (e) { return e.key === 'Enter' && validateTotp(); }, value: totp, placeholder: "Input code here", fullWidth: true, error: !!errorMsg, helperText: errorMsg }), (0, jsx_runtime_1.jsx)(BlendButton_1.default, __assign({ onClick: validateTotp, disabled: (totp === null || totp === void 0 ? void 0 : totp.length) < 6, fullWidth: true, size: "large", isSending: loading }, { children: "Submit" })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ display: "flex", justifyContent: "center", width: 1 }, { children: (0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ onClick: close, size: "small", color: "neutral" }, { children: "Go back" })) }))] })) })));
};
exports.default = TotpInput;
